import { __awaiter } from "tslib";
import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import stepByStepValidate from '@/services/_helpers/stepByStepValidate';
import SERVICES from '@/constants/services';
import { LevelName } from './types';
import { getPassportUrl } from '@/utils/other';
export default Vue.extend({
    props: {
        slotData: {
            type: Object,
            required: true
        }
    },
    name: 'emailSMSConfirmPopupChunk',
    data: () => ({
        step: 1,
        form: {
            fields: {
                emailCode: {
                    valid: false,
                    codeIsSent: false,
                    codeSentBefore: false,
                    retryTimeout: 60,
                    retries: 3,
                    letRetry: false,
                    value: '',
                    rules: [
                        (v) => Boolean(v) || 'Поле обязательно',
                        (v) => v.length === SERVICES.CODE_LENGTH || `Код должен состоять из ${SERVICES.CODE_LENGTH} символов`
                    ],
                    sending: false,
                    isLoading: false,
                    responseErrors: []
                },
                smsCode: {
                    valid: false,
                    codeIsSent: false,
                    codeSentBefore: false,
                    retryTimeout: 60,
                    retries: 3,
                    letRetry: false,
                    value: '',
                    rules: [
                        (v) => Boolean(v) || 'Поле обязательно',
                        (v) => v.length === SERVICES.CODE_LENGTH || `Код должен состоять из ${SERVICES.CODE_LENGTH} символов`
                    ],
                    sending: false,
                    isLoading: false,
                    responseErrors: []
                }
            }
        }
    }),
    computed: Object.assign({}, mapGetters('user', ['getUserData'])),
    watch: {
        'form.fields.emailCode.retryTimeout'(v) {
            const vm = this;
            if (v > 0) {
                setTimeout(() => {
                    vm.form.fields.emailCode.retryTimeout = v - 1;
                }, 1000);
            }
            else
                vm.form.fields.emailCode.letRetry = true;
        },
        'form.fields.smsCode.retryTimeout'(v) {
            const vm = this;
            if (v > 0) {
                setTimeout(() => {
                    vm.form.fields.smsCode.retryTimeout = v - 1;
                }, 1000);
            }
            else
                vm.form.fields.smsCode.letRetry = true;
        },
        'form.fields.emailCode.valid'(v) {
            if (v && this.form.fields.emailCode.value.length > 0)
                this.validateFirstStep();
        },
        'form.fields.smsCode.valid'(v) {
            if (v && this.form.fields.smsCode.value.length > 0)
                this.validateSecondStep();
        },
        'form.fields.emailCode.value'() {
            this.form.fields.emailCode.responseErrors = [];
        },
        'form.fields.smsCode.value'() {
            this.form.fields.smsCode.responseErrors = [];
        }
    },
    created() {
        this.sendEmail();
    },
    methods: {
        hasntAccessHandler() {
            const hasCurrentMethod = this.getUserData.currentAccessRepairMethods.includes('sms');
            const vm = this;
            if (hasCurrentMethod) {
                this.$store.dispatch('popupModule/openPopup', {
                    type: 'confirmPopup',
                    letDefaultClose: true,
                    title: 'Предупреждение',
                    content: 'В данный момент идет восстановление телефона, установленного как метод 2FA для подтверждения операций в Личном кабинете. Вы сможете выполнить операцию после завершения восстановления.',
                    actions: [
                        {
                            title: 'Хорошо',
                            isAccent: true,
                            callback() { vm.$store.commit('popupModule/setClosed'); }
                        }
                    ]
                });
                return;
            }
            const isBasic = this.getUserData.verificationRights.levelName === LevelName.basic;
            if (isBasic) {
                vm.$store.dispatch('popupModule/openPopup', {
                    type: 'confirmPopup',
                    letDefaultClose: false,
                    title: 'Восстановление телефона',
                    content: 'Чтобы восстановить телефон, нужно пройти расширенную верификацию аккаунта.',
                    actions: [
                        {
                            title: 'К разделу',
                            isAccent: true,
                            callback() {
                                vm.$store.commit('popupModule/setClosed');
                                window.location.href = getPassportUrl('/id/', { withAcceptor: true });
                            }
                        },
                        {
                            title: 'Позже',
                            isAccent: false,
                            callback() {
                                vm.$store.commit('popupModule/setClosed');
                            }
                        }
                    ]
                });
                return;
            }
            this.$router.push({ name: 'AccessRepair', query: { secondFactor: 'sms', an3K8QkkJb3Mzz: this.slotData.sessionId } });
        },
        sendEmail() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.form.fields.emailCode.codeSentBefore = false;
                vm.form.fields.emailCode.sending = true;
                const response = yield vm.services.mainService.sendCode(vm.slotData.codes.email.type);
                vm.form.fields.emailCode.sending = false;
                if (response.success) {
                    vm.form.fields.emailCode.codeIsSent = true;
                    vm.form.fields.emailCode.letRetry = false;
                    vm.form.fields.emailCode.retryTimeout = moment(response.data.repeatAfter).diff(moment(), 'seconds');
                    vm.form.fields.emailCode.retries -= 1;
                    setTimeout(() => {
                        vm.form.fields.emailCode.retryTimeout -= 1;
                    }, 1000);
                }
                else {
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.repeatAfter) {
                        vm.form.fields.emailCode.codeSentBefore = true;
                        vm.form.fields.emailCode.codeIsSent = true;
                        vm.form.fields.emailCode.letRetry = false;
                        vm.form.fields.emailCode.retryTimeout = moment(response.data.repeatAfter).diff(moment(), 'seconds');
                        vm.form.fields.emailCode.retries -= 1;
                        setTimeout(() => {
                            vm.form.fields.emailCode.retryTimeout -= 1;
                        }, 1000);
                    }
                    else {
                        vm.form.fields.emailCode.codeSendError = true;
                        vm.form.fields.emailCode.letRetry = true;
                    }
                }
            });
        },
        sendSMS() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.form.fields.smsCode.codeSentBefore = false;
                vm.form.fields.smsCode.sending = true;
                const response = yield vm.services.mainService.sendCode(vm.slotData.codes.sms.type);
                vm.form.fields.smsCode.sending = false;
                if (response.success) {
                    vm.form.fields.smsCode.codeIsSent = true;
                    vm.form.fields.smsCode.letRetry = false;
                    vm.form.fields.smsCode.retryTimeout = moment(response.data.repeatAfter).diff(moment(), 'seconds');
                    vm.form.fields.smsCode.retries -= 1;
                    setTimeout(() => {
                        vm.form.fields.smsCode.retryTimeout -= 1;
                    }, 1000);
                }
                else {
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.repeatAfter) {
                        vm.form.fields.smsCode.codeSentBefore = true;
                        vm.form.fields.smsCode.codeIsSent = true;
                        vm.form.fields.smsCode.letRetry = false;
                        vm.form.fields.smsCode.retryTimeout = moment(response.data.repeatAfter).diff(moment(), 'seconds');
                        vm.form.fields.smsCode.retries -= 1;
                        setTimeout(() => {
                            vm.form.fields.smsCode.retryTimeout -= 1;
                        }, 1000);
                    }
                    else {
                        vm.form.fields.smsCode.codeSendError = true;
                        vm.form.fields.smsCode.letRetry = true;
                    }
                }
            });
        },
        validateFirstStep() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.form.fields.emailCode.responseErrors = [];
                vm.form.fields.emailCode.isLoading = true;
                setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                    const response = yield stepByStepValidate({
                        name: vm.slotData.name,
                        endpointName: vm.slotData.endpointName,
                        data: {
                            sessionId: vm.slotData.sessionId,
                            payload: { email: vm.form.fields.emailCode.value }
                        },
                        steps: vm.slotData.steps
                    });
                    vm.form.fields.emailCode.isLoading = false;
                    if (response.success) {
                        vm.sendSMS();
                        vm.step = 2;
                        return;
                    }
                    vm.form.fields.emailCode.responseErrors = response.errors;
                }), 1000);
            });
        },
        validateSecondStep() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.form.fields.smsCode.responseErrors = [];
                vm.form.fields.smsCode.isLoading = true;
                setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                    const response = yield stepByStepValidate({
                        name: vm.slotData.name,
                        endpointName: vm.slotData.endpointName,
                        data: {
                            sessionId: vm.slotData.sessionId,
                            payload: { sms: vm.form.fields.smsCode.value }
                        },
                        steps: vm.slotData.steps
                    });
                    vm.form.fields.smsCode.isLoading = false;
                    response.success ? vm.$emit('onSuccess') : vm.form.fields.smsCode.responseErrors = response.errors;
                }), 1000);
            });
        },
        handleCancel() {
            const vm = this;
            vm.$store.commit('popupModule/setClosed');
        }
    }
});
